import JsonLd from "./JsonLd";

const SITE_URL = "https://pawground.app";

/**
 * Site-wide JSON-LD schemas mounted exactly once at the app root.
 * Currently emits:
 *   - WebSite: lets Google show the sitelinks search box in SERPs and
 *     identifies the site name/description.
 *   - Organization: associates Pawground as a recognizable brand entity
 *     for Knowledge Graph + logo display in rich results.
 *
 * Per-page breadcrumb, item-list, and entity-type (Park/Restaurant/etc.)
 * schemas are emitted by each individual page component (see
 * Breadcrumbs.jsx, ParkDetail.jsx, CityPage.jsx, BlogPost.jsx).
 */
const WEBSITE_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Pawground",
  url: SITE_URL,
  description: "Find dog-friendly places near you",
  potentialAction: {
    "@type": "SearchAction",
    target: {
      "@type": "EntryPoint",
      urlTemplate: `${SITE_URL}/search?q={search_term_string}`,
    },
    "query-input": "required name=search_term_string",
  },
};

const ORGANIZATION_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Pawground",
  url: SITE_URL,
  logo: {
    "@type": "ImageObject",
    url: `${SITE_URL}/icon-512.png`,
  },
  sameAs: [SITE_URL],
};

const GlobalSchemas = () => (
  <>
    <JsonLd schema={WEBSITE_SCHEMA} id="global-website" />
    <JsonLd schema={ORGANIZATION_SCHEMA} id="global-organization" />
  </>
);

export default GlobalSchemas;
